<template>
  <div>
    <!-- Desktop variant -->
    <b-col cols="auto" class="ml-auto d-none d-lg-block mt-2 mt-sm-0 px-2">
      <b-button 
        class="ml-2 mt-2 mr-2" 
        @click="$emit('add-to-shopping-list')" 
        :disabled="selectedCount === 0" 
        :hidden="editable" 
        :variant="editable ? 'secundary' : 'primary'"
      >
        <b-icon :icon="editable ? 'basket2' : 'basket2-fill'" /> 
        Voeg {{ selectedCount }} items toe aan de boodschappenlijst
      </b-button>
    </b-col>
    
    <!-- Mobile variant -->
    <b-col cols="auto" class="ml-auto d-block d-lg-none p-0 px-2 mt-auto">
      <b-button 
        class="ml-2 mt-2 mr-2 btn-block ph-2" 
        @click="$emit('add-to-shopping-list')" 
        :disabled="selectedCount === 0" 
        :hidden="editable" 
        :variant="editable ? 'secundary' : 'primary'"
      >
        <b-icon :icon="editable ? 'basket2' : 'basket2-fill'" /> 
        Voeg {{ selectedCount }} items toe
      </b-button>  
    </b-col>
  </div>
</template>

<script>
export default {
  name: 'ShoppingListAddButton',
  props: {
    selectedCount: {
      type: Number,
      required: true
    },
    editable: {
      type: Boolean,
      default: false
    }
  }
};
</script>
